import '../../css/addGuestData.scss'

import DragAndDropUploader from 'components/ReusableComponents/DragAndDropUploader'
import { PMSsCanSwitchToOhip } from 'constants'
import PMSLogs from 'features/PMSLogs'
import { PMSs } from 'main/hotelBrandsAndChains'
import { Component, createRef } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { uploadedGuestData } from '../../actions/autoinvite'
import LocalUserService from '../../services/localUserService'
import UploadLogs from '../UploadLogs'
import ResnexusHelpDialog from './HelpDialogs/ResnexusHelpDialog'
import WebrezHelpDialog from './HelpDialogs/WebrezHelpDialog'
import PmsMessage from './PmsMessage'
import SwitchToOhip from './SwitchToOhip'

const PMSsNotSupportingNewOnboarding = [PMSs.webrezpro]

const PMSsSupportUpload = [
  PMSs.webrezpro,
  PMSs.opera,
  PMSs.operadefault,
  PMSs.marriottgxp,
  PMSs.skytouch,
  PMSs.roommaster,
  PMSs.maestro,
  PMSs.infor,
  PMSs.destiworld
]

function doesSubsidiarySupportNewOnboarding({ pms }) {
  if (PMSsNotSupportingNewOnboarding.includes(pms)) {
    return false
  }
  return true
}

const UploadStatusDialog = ({ children }) => {
  return <div className="add-guest-data__status-dialog">{children}</div>
}

class AddGuestData extends Component {
  constructor(props) {
    super(props)

    this.state = {
      status: 'waiting',
      isResnexusHelpDialogVisible: false,
      isWebrezHelpDialogVisible: false,
      isNewbie: false,
      showingHelp: false
    }
    this.userService = new LocalUserService()
    this.pond = createRef()
  }

  resetStatus = () => {
    this.setState({
      status: 'waiting'
    })
  }

  renderUploadStatusDialog = () => {
    const { status } = this.state

    if (status === 'waiting') {
      return null
    }

    if (status === 'uploading') {
      return (
        <div>
          <UploadStatusDialog>
            <i className="filepond-upload-icon"></i>
            <h3>Uploading CSV file</h3>
            <p>This will take a few seconds.</p>
          </UploadStatusDialog>
          <div className="add-guest-data__overlay"></div>
        </div>
      )
    }

    if (status === 'uploaded') {
      return (
        <div>
          <UploadStatusDialog>
            <h3>Uploaded file succesfully</h3>
            <p>Guest data has been added to our database.</p>
            <button onClick={this.resetStatus}>Close</button>
          </UploadStatusDialog>
          <div className="add-guest-data__overlay"></div>
        </div>
      )
    }

    if (status === 'errored') {
      return (
        <div>
          <UploadStatusDialog>
            <h3>Something went wrong with your file.</h3>
            <button onClick={this.resetStatus}>Try another file</button>
          </UploadStatusDialog>
          <div className="add-guest-data__overlay"></div>
        </div>
      )
    }
  }

  renderHelpDialog = () => {
    const { isResnexusHelpDialogVisible, isWebrezHelpDialogVisible } = this.state

    if (isResnexusHelpDialogVisible) {
      return (
        <ResnexusHelpDialog
          handleHideDialog={() => this.setState({ isResnexusHelpDialogVisible: false })}
        />
      )
    }

    if (isWebrezHelpDialogVisible) {
      return (
        <WebrezHelpDialog
          handleHideDialog={() => this.setState({ isWebrezHelpDialogVisible: false })}
        />
      )
    }
  }

  getHeader = isAdminMode => {
    if (isAdminMode) {
      return {
        'sp-auth': this.userService.getCurrentUserInfo().sessionId,
        uploadMode: 'demo'
      }
    } else {
      return {
        'sp-auth': this.userService.getCurrentUserInfo().sessionId
      }
    }
  }

  componentDidMount() {
    if (localStorage.getItem('firstTimeOnAddGuestData')) {
      this.setState({
        isNewbie: true
      })

      localStorage.removeItem('firstTimeOnAddGuestData')
    }
  }
  joyrideKey = 42

  render() {
    const { pms, currentSubsidiaryId: subsidiaryId } = this.props
    return (
      <>
        <div>
          <PmsMessage
            pmsLoginLink={
              doesSubsidiarySupportNewOnboarding({ subsidiaryId, pms })
                ? '/pms-login'
                : 'onboarding'
            }
            type={pms}
          />
        </div>
        {PMSsCanSwitchToOhip.includes(pms) && (
          <div>
            <SwitchToOhip
              pmsLoginLink={
                doesSubsidiarySupportNewOnboarding({ subsidiaryId, pms })
                  ? '/pms-login'
                  : 'onboarding'
              }
              type={pms}
            />
          </div>
        )}
        <div className="uploadLogs">
          {this.state.status !== 'uploading' && (
            <>
              {doesSubsidiarySupportNewOnboarding({ subsidiaryId, pms }) ? (
                <PMSLogs />
              ) : (
                <UploadLogs />
              )}
            </>
          )}
        </div>
        <div className="add-guest-data">
          {this.renderHelpDialog()}
          {this.renderUploadStatusDialog()}
          {PMSsSupportUpload.includes(pms) && (
            <div className="add-guest-data__container">
              <div className="add-guest-data__uploader">
                <DragAndDropUploader
                  labelIdle="
              <p class='filepond-p-mini'>drop files here</p>
              <span class='filepond-or'>or</span> <span class='filepond--label-action-mini'>Upload report file</span>"
                  url="/pms/upload"
                  ref={this.pond}
                  acceptedFileTypes={[
                    'text/csv',
                    'application/xml',
                    'text/xml, application/json'
                  ]}
                  headers={this.getHeader(
                    this.props.match.params.pathParam1 === 'adminMode'
                  )}
                  onData={formData => {
                    this.setState({ status: 'uploading' })
                    return formData
                  }}
                  onLoad={res => {
                    const data = JSON.parse(res)
                    if (data.isSuccess) {
                      setTimeout(() => {
                        this.setState({ status: 'uploaded' })
                        this.props.dispatch(uploadedGuestData())
                      }, 1000)
                    } else {
                      this.setState({ status: 'errored' })
                      this.pond.current.removeFiles()
                    }
                  }}
                  onError={res => console.warn('file response', res)}
                />
              </div>
            </div>
          )}
        </div>
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    currentPmsNeedSync: state.login.currentPmsNeedSync,
    pms: state.login.subsidiaryPMS,
    currentSubsidiaryId: state.login.currentHotelId
  }
}

export default withRouter(connect(mapStateToProps)(AddGuestData))
